/**
 * Hook to get device session hashes for RPC calls.
 * Memoizes the async hash computation.
 */
import { useState, useEffect } from "react";
import { getChildSession, getDeviceIdHash } from "@/lib/device";
import { sha256Hex } from "@/lib/crypto";

export interface DeviceHashes {
  deviceIdHash: string;
  sessionTokenHash: string;
}

export function useDeviceHashes(): DeviceHashes | null {
  const [hashes, setHashes] = useState<DeviceHashes | null>(null);
  const session = getChildSession();

  useEffect(() => {
    if (!session) {
      setHashes(null);
      return;
    }
    let cancelled = false;
    (async () => {
      const [deviceIdHash, sessionTokenHash] = await Promise.all([
        getDeviceIdHash(),
        sha256Hex(session.sessionToken),
      ]);
      if (!cancelled) setHashes({ deviceIdHash, sessionTokenHash });
    })();
    return () => { cancelled = true; };
  }, [session?.sessionToken]);

  return hashes;
}
